import { render, staticRenderFns } from "./FCurrencyField.vue?vue&type=template&id=53167b48&"
import script from "./FCurrencyField.vue?vue&type=script&lang=ts&"
export * from "./FCurrencyField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports